export default __webpack_public_path__ + "static/1058-271686ad34c374d5b76df27c0c66be24.gif";